export const CHANNEL_SPECIAL_OPTIONS = {
  createNew: "__create_new__",
  notUsed: "__not_used__",
} as const;

export type ChannelSelectorValue =
  | (typeof CHANNEL_SPECIAL_OPTIONS)[keyof typeof CHANNEL_SPECIAL_OPTIONS]
  | string;

export type ChannelDraftAssignment =
  | { mode: "not_used" }
  | { mode: "create_new" }
  | { mode: "existing_channel"; msChannelId?: string };

export type TableChannelAssignmentPayload =
  | {
      presetTableId: string;
      mode: "not_used" | "create_new";
    }
  | {
      presetTableId: string;
      mode: "existing_channel";
      msChannelId: string;
    };

export const getChannelAssignmentFromValue = (
  value: ChannelSelectorValue
): ChannelDraftAssignment => {
  if (value === CHANNEL_SPECIAL_OPTIONS.notUsed) {
    return { mode: "not_used" };
  }

  if (value === CHANNEL_SPECIAL_OPTIONS.createNew) {
    return { mode: "create_new" };
  }

  return { mode: "existing_channel", msChannelId: value };
};

export const getChannelSelectedOptions = (
  assignment: ChannelDraftAssignment
): string[] => {
  if (assignment.mode === "not_used") {
    return [CHANNEL_SPECIAL_OPTIONS.notUsed];
  }

  if (assignment.mode === "create_new") {
    return [CHANNEL_SPECIAL_OPTIONS.createNew];
  }

  return assignment.msChannelId ? [assignment.msChannelId] : [];
};

export const getTableChannelAssignmentPayload = (
  presetTableId: string,
  assignment: ChannelDraftAssignment
): TableChannelAssignmentPayload => {
  if (assignment.mode === "existing_channel" && assignment.msChannelId) {
    return {
      mode: "existing_channel",
      msChannelId: assignment.msChannelId,
      presetTableId,
    };
  }

  return {
    mode: assignment.mode === "create_new" ? "create_new" : "not_used",
    presetTableId,
  };
};

export const getChannelValueLabel = (
  assignment: ChannelDraftAssignment,
  channelNameById: Map<string, string>
): string => {
  if (assignment.mode === "not_used") {
    return "Do not use";
  }

  if (assignment.mode === "create_new") {
    return "Create new";
  }

  if (!assignment.msChannelId) {
    return "Select a channel";
  }

  return channelNameById.get(assignment.msChannelId) ?? "Select a channel";
};
